import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import cookie, { type CookieAttributes } from 'js-cookie';
import { TRANSLATIONS_EN } from './en';
import { TRANSLATIONS_FR } from './fr';

export const resources = {
  en: {
    translation: TRANSLATIONS_EN,
  },
  fr: {
    translation: TRANSLATIONS_FR,
  },
};

export const defaultNS = 'translation'

i18n.use(initReactI18next).init({
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
  lng: cookie.get('django_language') || 'en',
  resources,
});

i18n.on('languageChanged', (lang) => {
  cookie.set('django_language', lang, cookieCrossEnv);
});

export default i18n;

const cookieCrossEnv: CookieAttributes = {
  domain: window.location.hostname.includes('.unbooking.org')
    ? '.unbooking.org'
    : window.location.hostname,
  sameSite: 'None',
  secure: true,
};